import { makeStyles } from "@material-ui/core/styles"

export const useCalendarContentStyles = makeStyles(() => ({
    root: {
        borderTop: "2px solid #ddd",
        width: "100%",
        position: "relative",
        height: "63vh",
        overflowY: "scroll",
    },
    item: {
        display: "flex",
        width: "100%",
    },
    weChatItem: {
        "&:nth-child(5n + 1)": {
            marginTop: 20,
            borderTop: "2px solid #ddd",
        },
    },
    label: {
        width : "130px",
        borderBottom: "1px solid #ddd",
        borderRight: "1px solid #ddd",
        padding: "2px 4px",
        userSelect: "none",
        minHeight: 50,
        flexShrink: 0,
    },
    moveMask: {
        width: "99%",
        height: "99%",
        backgroundColor: "rgba(0,0,0,.2)",
        borderRadius: 6,
        zIndex: 1,
    },
}))

export const useItemWrapStyles = makeStyles({
    root: {
        width: "100%",
        borderBottom: "1px solid #ddd",
        borderRight: "1px solid #ddd",
        flexShrink: 1,
        position: "relative",
    },
})
